export default function StatsBar() {
  return (
    <section className="py-3 bg-white border-bottom">
      <div className="container">
        <div className="row text-center g-3">
          <div className="col-6 col-md-3">
            <div className="fw-bold text-primary">HIPAA-aware</div>
            <div className="text-secondary small text-danger">Privacy-first processes</div>
          </div>
          <div className="col-6 col-md-3">
            <div className="fw-bold text-primary">Fully insured</div>
            <div className="text-secondary small  text-danger">Commercial & auto</div>
          </div>
          <div className="col-6 col-md-3">
            <div className="fw-bold text-primary">Background checked</div>
            <div className="text-secondary small  text-danger">Driver screenings</div>
          </div>
          <div className="col-6 col-md-3">
            <div className="fw-bold text-primary">On-time 98%</div>
            <div className="text-secondary small  text-danger">Punctual pickups</div>
          </div>
        </div>
      </div>
    </section>
  );
}
